import axiosInstance from "../axiosInstance";

// first signup api
export const sendOtpApi = async (formdata) => {
  try {
    const response = await axiosInstance.post("/Account/SendOtp", formdata);
    return response.data;
  } catch (error) {
    // console.log(error.response && error.response.data.message);
  }
};

export const validateOtpApi = async (formdata) => {
  try {
    const response = await axiosInstance.post("/Account/ValidateOtp", formdata);
    return response.data;
  } catch (error) {
    return { status: false };
  }
};
// third api create password
export const signupApi = async (formdata) => {
  try {
    const response = await axiosInstance.post("/Account/SignUp", formdata);
    return response.data;
  } catch (error) {
    return error;
  }
};

// fourth api login
export const loginApi = async (formdata) => {
  try {
    const response = await axiosInstance.post("/Account/Login", formdata);

    await localStorage.clear();
    await localStorage.setItem("AUTH_ACCESS_TOKEN", response.data.data.token);
    await localStorage.setItem(
      "AUTH_REFRESH_TOKEN",
      response.data.data.refreshToken
    );
    await localStorage.setItem(
      "AUTH_USER",
      JSON.stringify(response.data.data.userInfo)
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
export const GetMultiStepper = async (userId) => {
  try {
    const response = await axiosInstance.get(
      `Account/GetMultiStepper?userId=${userId}`
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
export const UpdateMultiStepper = async (userId, stepName) => {
  try {
    const response = await axiosInstance.post(`Account/UpdateMultiStepper`, {
      userId,
      [stepName]: true,
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { status: false, message: "Unknown error" };
  }
};
// fifth api forgot password

export const forgotPassApi = async (formdata) => {
  try {
    const response = await axiosInstance.post(
      "/Account/ForgotPassword",
      formdata
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// sixth api reset password

export const resetPassword = async (formdata) => {
  try {
    const response = await axiosInstance.post(
      "/Account/ResetPassword",
      formdata
    );

    return response.data;
  } catch (error) {
    // console.log(error, "error====");
  }
};

// Get All Users
export const checkEmailExistsApi = async (email) => {
  try {
    const response = await axiosInstance.get("/Account/GetAllUsers", {
      email,
    });
    return response.data;
  } catch (error) {}
};
export const UpdateCustomSettingTemplate = async (
  updateEntity,
  data,
  templateID
) => {
  try {
    const response = await axiosInstance.post(
      `Account/UpdateCustomSettingTemplate`,
      {
        templateId: templateID,
        // templateId: "DC7DE00D-CDEB-474A-9046-48AB2D0E2D57",
        [updateEntity]: data,
      }
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { status: false, message: "Unknown error" };
  }
};

export const GetCustomSettingTemplate = async () => {
  try {
    const response = await axiosInstance.get(
      "Account/GetCustomSettingTemplate",
      {
        headers: {
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { status: false, message: "Unknown error" };
  }
};
export const logoutApi = async (token, refreshToken) => {
  try {
    const response = await axiosInstance.post(
      `/Account/Logout?token=${token}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const refreshToken = async (token, refreshToken) => {
  try {
    const response = await axiosInstance.post(
      `/Account/RefreshToken?accessToken=${token}&refreshToken=${refreshToken}`,
      {}
    );
    return response.data;
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
};

export const changePassword = async (
  email,
  oldPassword,
  newPassword,
  confirmPassword
) => {
  try {
    const response = await axiosInstance.post("/Account/ChangePassword", {
      email,
      oldPassword,
      newPassword,
      confirmPassword,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
